export default {
  control_panel: "Control Panel",
  install_from_app_store: "Don't have an account? Install from App Store",
  login: {
    title: "Log in to Dataships",
    description: "Welcome back! Please enter your details",
    form: {
      email: "Email",
      password: "Password",
      forgotPassword: "Forgot Password?",
      logIn: "Log in",
      errors: {
        emailInvalid: "Please provide a valid email address.",
        emailRequired: "Email is a required field.",
        passwordRequired: "Password is a required field.",
      },
    },
    alerts: {
      sessionTimeout: "Your session has timed out. Please log in to continue.",
      installationInProgress: {
        title: "Installation In-progress",
        description:
          "To complete your installation, please log in with your Dataships account below.",
      },
    },
  },
  company_selector: {
    heading: "Select an account below",
    search_placeholder: "Search...",
    no_results: "No customers found for '{{search}}'",
    buttons: {
      back: "Back to sign in",
    },
  },
  resetPassword: {
    title: "Reset your password",
    description: "Please fill in all of the fields below",
    form: {
      newPassword: {
        label: "New Password",
        errors: {
          required: "You must provide a password",
          length: "Your password must be at least 10 characters long",
        },
      },
    },
    buttons: {
      resendLink: "Resend Verification Link",
      update: "Update Password",
    },
    success: "Password reset success!",
    resendSuccess: "A new verification link has been sent.",
    compromisedPassword:
      "This password has been flagged as compromised. Please choose a stronger password.",
    expiredToken: "Oops! Your token is expired.",
  },
  forgotPassword: {
    title: "Reset your password",
    subtitle: "Enter your email to receive a password reset link",
    input: {
      label: "Email",
      requiredError: "You must enter your email address",
      emailInvalid: "Please provide a valid email address.",
    },
    button: "Submit",
    success:
      "An email will be sent with a reset password link if this is a valid profile with us.",
  },
  verifyEmail: {
    heading: {
      header: "Verify your email address",
      description:
        "We emailed you a 6 digit code to <1>{{ email }}</1>. Enter the code below to verify your email address.",
    },
    inputLabel: "Code",
    submitCta: "Submit",
    resendCta: "Resend",
    resendLabel: "Didn't receive a code?",
    countdown: "Resend email in {{secondsRemaining}}",
    success: "Email Address verified",
    resendSuccess: "A new verification code has been sent.",
    errors: {
      invalid: "Incorrect verification code",
      expired:
        "This code has expired. Please click 'Resend' to receive a new code.",
      empty: "You must input a verification code",
      tooShort: "Your verification code must be 6 characters long",
      unableToVerify:
        "Unable to verify code. Please try again, or contact support if this issue persists.",
    },
  },
  verifyEmailExisting: {
    heading: {
      header: "Welcome Back!",
      description:
        "The Dataships app has been successfully reinstalled on your Shopify store. To continue, enter your email address below and we’ll send you a verification code. Once you receive it, enter the code to confirm your email address and log in to your Dataships account.This helps us protect your account and your customers’ data.",
    },
    inputLabel: "Email",
    submitCta: "Submit",
    sendSuccess: "Email sent! Please check your email for a code!",
    resendSuccess:
      "A new email has been sent. Please check your email for a link.",
    resendCta: "Resend",
    resendLabel: "Didn't receive an email?",
    countdown: "Resend email in {{secondsRemaining}}",
  },
} as const;
